// @flow
import createIcon from './utils/createIcon'

export default createIcon({
  iconName: 'tickets',
  icon: [
    18,
    16,
    null,
    null,
    'M11.51 11a1.01 1.01 0 0 1-.05-.12L8.72 4.1 2.05 6.8l2.78 6.88L11.5 11zm1.84-.75l2.6-1.05-2.78-6.9-2.6 1.06 2.74 6.77.04.12zm-10.38 4.2L.2 7.54a2 2 0 0 1 1.1-2.6L12.43.45a2 2 0 0 1 2.6 1.1l2.79 6.9a2 2 0 0 1-1.1 2.6l-11.13 4.5a2 2 0 0 1-2.6-1.1z',
  ],
})
